import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import API from "./API";
import { Header } from '../Header';
import { Footer } from '../Footer';

export default class APIList extends Base {
    constructor(props) {
        super(props);
        this.state = {
            caller: props.Caller,
            inline: this.isNull(props.Inline) ? false : props.Inline,
            controllerName: 'api',
            data: null,
            page: 1,
            per_page: 30,
            phrase: '',
            loading: true,
            menuId: 114
        };

        this.state.filters = {
            status: 0,
        }
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.refreshData();
    }
    onEdit(id) {
        this.removeKeyDown();
        this.showComponents({ component: <API Caller={this} Id={id} /> });
    }
    onAdd() {
        this.removeKeyDown();
        this.showComponents({ component: <API Caller={this} /> });
    }
    renderForm() {
        return <div>
            <div className="nk-content-body">
                <div className="nk-block-head nk-block-head-sm">
                    <div className="nk-block-between">
                        <div className="nk-block-head-content">
                            <h3 className="nk-block-title page-title">فهرست دسترسی های API</h3>
                            <div className="nk-block-des text-soft">
                                <p>{this.money(this.state.data.recordsCount)} توکن یافت شد</p>
                            </div>
                        </div>
                        <div className="nk-block-head-content">
                            <div className="toggle-wrap nk-block-tools-toggle">
                                <a href="#" className="btn btn-icon btn-trigger toggle-expand me-n1" data-target="pageMenu"><em className="icon ni ni-menu-alt-r"></em></a>
                                <div className="toggle-expand-content" data-content="pageMenu">
                                    <ul className="nk-block-tools g-3">
                                        <li>
                                            <a className="hand btn btn-primary" onClick={e => this.onAdd()}><em className="icon ni ni-plus"></em>
                                                <span>ایجاد توکن جدید</span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {this.renderView()}
            </div>
        </div>
    }
    renderView() {
        return <div className="nk-block">
            <div className="card card-bordered card-stretch">
                <div className="card-inner-group">
                    <div className="card-inner position-relative card-tools-toggle">
                        <div className="card-title-group">
                            <form className="card-tools" mthod="post" onSubmit={e => this.refreshData(e)}>
                                <div className="form-inline flex-nowrap gx-3">
                                    <div className="form-wrap">
                                        <input type="text" defaultValue={this.state.phrase} onChange={e => this.state.phrase = e.target.value} placeholder={"توکن"} className="form-control" />
                                    </div>
                                    <div className="form-wrap">
                                        <select defaultValue={this.state.filters.status} onChange={e => this.state.filters.status = parseInt(e.target.value)} className="form-control">
                                            <option value="0">همه وضعیتها</option>
                                            <option value="1">فعال</option>
                                            <option value="2">غیرفعال</option>
                                        </select>
                                    </div>
                                    <div className="btn-wrap">
                                        <span className="d-none d-md-block"><button onClick={e => this.refreshData(e)} type="submit" className="btn btn-dim btn-outline-light hand"><em class="icon ni ni-search"></em> جستجو</button></span>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    {this.state.data.recordsCount <= 0 ?
                        <div className="card-inner-group">
                            <div className="example-alert">
                                <div className="alert alert-pro alert-warning">
                                    <div className="alert-text">
                                        <h6>توجه</h6>
                                        <p>هیچ توکنی یافت نشد</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        <div className="card-inner p-0">
                            <div className="nk-tb-list nk-tb-ulist">
                                <div className="nk-tb-item nk-tb-head">
                                    <div className="nk-tb-col text-center"><span className="sub-text">توکن</span></div>
                                    <div className="nk-tb-col text-center"><span className="sub-text">وضعیت</span></div>
                                    <div className="nk-tb-col text-end"><span className="sub-text">عملیات</span></div>
                                </div>
                                {this.state.data.records.map((record, index) =>
                                    <div className="nk-tb-item">
                                        <div className="nk-tb-col">
                                            <span className="sub-text text-center">
                                                <a className="text-primary txt-bold hand" onClick={e => this.onEdit(record.id)} title="مشاهده و ویرایش">
                                                    {record.token}
                                                </a>
                                            </span>
                                        </div>
                                        <div className="nk-tb-col">
                                            <span className="sub-text text-center">{record.statusString}</span>
                                        </div>
                                        <div className="nk-tb-col text-end">
                                            <a className="hand text-primary mx-1" onClick={e => this.onEdit(record.id)} title="ویرایش">
                                                <em className="icon ni ni-pen"></em>
                                            </a>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    }
                    {this.createPaging()}
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.state.loading && !this.hasPermission(this.state.menuId)) return this.renderPermissionDenied();
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.isEmpty(this.state.data.global.companies) ? [
                    <Header data={this.state.data} />,
                    <div className="nk-content ">
                        <div className="container-fluid">
                            <div className="nk-content-inner">
                                {this.renderNoCompanyRegister()}
                            </div>
                        </div>
                    </div>,
                    <Footer />,
                ] :
                    this.state.inline ? this.renderView() :
                        [
                            <Header data={this.state.data} />,
                            <div className="nk-content ">
                                <div className="container-fluid">
                                    <div className="nk-content-inner">
                                        {this.renderForm()}
                                    </div>
                                </div>
                            </div>,
                            <Footer />,
                        ]
                ,
                this.renderPopupComponent(),
            ];

        return contents;
    }
}